import React, { useEffect, useState, useMemo, useContext } from "react";
import Navlogo from "../../assets/images/logo/NavLogo.png";
import axios from "axios";
import html2canvas from "html2canvas";
import { Card, Row } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./PrescriptionPreview.scss";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { displayPatientName } from "../../utils/displayPatientName";
import { displayDoctorName } from "../../utils/displayDoctorName";
import {
  Modal,
  Box,
  Typography,
  Button as muiButton,
  IconButton,
  Grid,
  Divider,
} from "@mui/material";
import HealingIcon from "@mui/icons-material/Healing"; // Import other relevant icons
import VisibilityIcon from "@mui/icons-material/Visibility";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AssignmentIcon from "@mui/icons-material/Assignment";

import {
  formatDateIST,
  getHumanReadableDiffInPastDateWithAgo,
  getHumanReadableDurationInDate,
  renderEachSection,
} from "../../pages/doctor-console/Utils/UtilsFunctions";
import {
  formatHistoryOnsetForPdf,
  formatHistoryDurationForPdf,
} from "../../pages/doctor-console/Utils/pdfHistoryFormatters";
import { formatOnsetDurationForPdf } from "../../pages/doctor-console/HistoriesData/durationUtils";
import PdfHeader from "../../pages/doctor-console/PdfDatas/PdfHeader";
import PdfFooter from "../../pages/doctor-console/PdfDatas/PdfFooter";
import { sections } from "../../pages/doctor-console/initialData/initialData";
import { BrandingContext } from "../../BrandingProvider";
import PdfHeaderDocs from "../../pages/doctor-console/PdfDatas/PdfHeaderDocs";
import NavLogoFooter from "../../assets/images/logo/NavLogo_new.png";
import { usePermissions } from "../../pages/login/PermissionContext";
import { isTodayOrFuture } from "../../pages/utils/utils";
const PrescriptionPreview = ({
  source,
  selectedSectionsData,
  historyDetails,
  sectionsContent,
  doctorData,
  hasVitalValue,
  vitals,
  hasDentalData,
  dentalData,
  prescribedMedicines,
  patientData,
  bloodGroup,
  otherExaminations,
  selectedContext,
  selectedContextDisplay,
  followUpError,
  referralError,
  departments,
  dateForAppointment,
  startTime,
}) => {
  // const [facilityDetails, setFacilityDetails] = useState(null);
  console.log("DoctorData from preview page", doctorData);
  console.log("Selected Section Data from preview page", selectedSectionsData);
  console.log("History Details", historyDetails);
  console.log("dateForAppointment from preview page", dateForAppointment);
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const brandingData = useContext(BrandingContext);
  const brandingItem = brandingData?.find(
    (item) => item.name === "branding_statements"
  );
  const collateralBrandStatement =
    brandingItem?.content?.collateralBrandStatement || "";
  const collateralImage =
    brandingData?.find((item) => item.name === "collateral_image")?.content ||
    "";
  // useEffect(() => {
  //   getAllDepartments();
  // }, []);
  // const getAllDepartments = () => {
  //   axios
  //     .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_departments/`, {
  //       headers,
  //     })
  //     .then((res) => {
  //       console.log("Res Data", res);
  //       if (res.data.status != "Failed") {
  //         setDepartments(res.data.department_list);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const pageWidth = 595.28;
  const pageHeight = 841.89;
  const margin = 40;

  // Main PDF Export Function
  // const handleDownload = () => {
  //   const doc = new jsPDF({
  //     orientation: "p",
  //     unit: "pt",
  //     format: "a4",
  //     compress: true,
  //   });

  //   const brandingItem = brandingData?.find(
  //     (item) => item.name === "branding_statements"
  //   );
  //   const themeColour = brandingItem?.content?.themeColour || "#21cdc0";

  //   let currentY = margin + 220; // space for header
  //   currentY = renderChiefComplaintsToPdf(
  //     doc,
  //     currentY,
  //     themeColour,
  //     selectedSectionsData["Chief Complaints"] || []
  //   );
  //   const renderHistorySectionGroup = (
  //     doc,
  //     startY,
  //     themeColour,
  //     title,
  //     entries
  //   ) => {
  //     let currentY = startY;
  //     const hasAnyData = Object.values(entries).some(
  //       (section) =>
  //         (section?.prev?.length ?? 0) > 0 || (section?.new?.length ?? 0) > 0
  //     );

  //     if (!hasAnyData) {
  //       return currentY; // Skip rendering completely
  //     }

  //     const renderLabel = (text, fontSize = 12) => {
  //       doc.setFontSize(fontSize);
  //       doc.setTextColor("#000");
  //       doc.text(text, margin, currentY);
  //       currentY += 15;
  //     };

  //     renderLabel("History", 14);

  //     const recentSections = [];
  //     const oldSections = [];

  //     for (const [sectionName, sectionValue] of Object.entries(entries)) {
  //       const prev = sectionValue?.prev ?? [];
  //       const current = sectionValue?.new ?? [];
  //       if (current.length > 0) {
  //         recentSections.push({ sectionName, data: current });
  //       }
  //       if (prev.length > 0) {
  //         oldSections.push({ sectionName, data: prev });
  //       }
  //     }

  //     if (recentSections.length > 0) {
  //       renderLabel("Recent Data", 12);
  //       for (const section of recentSections) {
  //         renderLabel(`• ${section.sectionName}`, 10);
  //         autoTable(doc, {
  //           startY: currentY,
  //           head: [getHeaders(section.sectionName)],
  //           body: section.data.map((item) =>
  //             formatRowData(section.sectionName, item)
  //           ),
  //           theme: "striped",
  //           styles: { fontSize: 8 },
  //           headStyles: { fillColor: hexToRgbArray("#EEEEEE"), textColor: hexToRgbArray("#000000") },
  //           margin: { top: 250, left: margin, right: margin, bottom: 200 },
  //           didDrawPage: (data) => renderHeaderFooter(data, doc),
  //           pageBreak: "auto",
  //         });
  //         currentY = doc.lastAutoTable.finalY + 10;
  //       }
  //     }

  //     if (oldSections.length > 0) {
  //       renderLabel("Old Data", 12);
  //       for (const section of oldSections) {
  //         renderLabel(`• ${section.sectionName}`, 10);
  //         autoTable(doc, {
  //           startY: currentY,
  //           head: [getHeaders(section.sectionName)],
  //           body: section.data.map((item) =>
  //             formatRowData(section.sectionName, item)
  //           ),
  //           theme: "striped",
  //           styles: { fontSize: 8 },
  //           headStyles: { fillColor: hexToRgbArray("#EEEEEE"), textColor: hexToRgbArray("#000000") },
  //           margin: { top: 250, left: margin, right: margin, bottom: 200 },
  //           didDrawPage: (data) => renderHeaderFooter(data, doc),
  //           pageBreak: "auto",
  //         });
  //         currentY = doc.lastAutoTable.finalY + 10;
  //       }
  //     }

  //     return currentY;
  //   };
  //   currentY = renderInitialObservationToPdf(
  //     doc,
  //     currentY,
  //     themeColour,
  //     selectedSectionsData["InitialObservation"] || []
  //   );
  //   currentY = renderHistorySectionGroup(
  //     doc,
  //     currentY,
  //     themeColour,
  //     "History",
  //     historyDetails
  //   );
  //   currentY = renderExaminationsToPdf(
  //     doc,
  //     currentY,
  //     themeColour,
  //     vitals,
  //     bloodGroup,
  //     dentalData
  //   );

  //   currentY = renderInvestigationToPdf(
  //     doc,
  //     currentY,
  //     themeColour,
  //     selectedSectionsData["Tests/Investigations"] || []
  //   );
  //   currentY = renderOtherSectionsToPdf(
  //     doc,
  //     currentY,
  //     themeColour,
  //     selectedSectionsData["Diagnosis"] || []
  //   );

  //   if (selectedSectionsData["Medications"]?.length > 0) {
  //     doc.setFontSize(14);
  //     doc.setTextColor("#000");
  //     doc.text("Medications", margin, currentY);
  //     currentY += 15;

  //     autoTable(doc, {
  //       startY: currentY,
  //       head: [
  //         [
  //           "Drug",
  //           "Frequency",
  //           "Route",
  //           "Duration",
  //           //  "Instruction",
  //           "Reason",
  //           "Note",
  //         ],
  //       ],
  //       body: selectedSectionsData["Medications"].map((item) => [
  //         item.term || "-",
  //         Array.isArray(item?.frequency)
  //           ? item?.frequency.map((option) => option.term).join(", ")
  //           : item?.frequency || "-",
  //         item.selectedAdministration?.label || "-",
  //         item.duration ? `${item.duration} ${item.durationType}` : "-",
  //         // item.instructions || "-",
  //         item.reasons.join(", ") || "-",
  //         item.medicineNote || "-",
  //       ]),
  //       theme: "striped",
  //       styles: { fontSize: 8 },
  //       headStyles: { fillColor: hexToRgbArray("#EEEEEE"), textColor: hexToRgbArray("#000000") },
  //       margin: { top: 250, left: margin, right: margin, bottom: 200 },
  //       didDrawPage: (data) => renderHeaderFooter(data, doc),
  //     });

  //     currentY = doc.lastAutoTable.finalY + 20;
  //   }

  //   currentY = renderProceduresToPdf(
  //     doc,
  //     currentY,
  //     themeColour,
  //     selectedSectionsData["Procedures"] || []
  //   );

  //   currentY = renderMedicalAdviceToPdf(
  //     doc,
  //     currentY,
  //     themeColour,
  //     selectedSectionsData["MedicalAdvice"] || {}
  //   );

  //   currentY = renderAppointmentToPdf(
  //     doc,
  //     currentY,
  //     themeColour,
  //     selectedSectionsData["FollowUp"],
  //     selectedSectionsData["Referral"]
  //   );

  //   // Ensure footer is added on every page (even non-autoTable ones)
  //   const totalPages = doc.internal.getNumberOfPages();

  //   for (let i = 1; i <= totalPages; i++) {
  //     doc.setPage(i);
  //     renderHeaderFooter({}, doc); // add header
  //     renderFooter(doc, i); // add footer with correct page number
  //   }

  //   doc.save("op_consultation.pdf");
  // };

  const hasObservationValue = (value) => {
    if (value === 0 || value === "0") return true;
    if (value === undefined || value === null) return false;
    return String(value).trim().length > 0;
  };

  const getPanelsWithObservationValues = (panels = []) =>
    Array.isArray(panels)
      ? panels
        .map((panel) => ({
          ...panel,
          tests: (panel?.tests || []).filter((test) =>
            hasObservationValue(test?.value)
          ),
        }))
        .filter((panel) => panel.tests.length > 0)
      : [];

  const renderInvestigationToPdf = (
    doc,
    startY,
    themeColour,
    investigationData
  ) => {
    if (!Array.isArray(investigationData) || investigationData.length === 0) {
      return startY;
    }

    doc.setFontSize(14);
    doc.setTextColor("#000");
    doc.text("Tests Advised", margin, startY);
    startY += 15;

    const content = investigationData.map((data, index) => {
      const line1 = `${index + 1}. ${data.term || ""}${data.body_part ? `, ${data.body_part}` : ""
        }${data.laterality ? `, ${data.laterality}` : ""}${data.position ? `, ${data.position}` : ""
        }`;

      const line2 = data.clinical_note
        ? `Clinical Note - ${data.clinical_note}`
        : "";

      return [`${line1}${line2 ? `\n${line2}` : ""}`];
    });

    autoTable(doc, {
      startY,
      head: [["Tests Advised"]],
      body: content,
      theme: "grid",
      styles: { fontSize: 9 },
      headStyles: { fillColor: hexToRgbArray("#EEEEEE"), textColor: hexToRgbArray("#000000") },
      margin: { top: 250, left: margin, right: margin, bottom: 200 },
      didDrawPage: (data) => renderHeaderFooter(data, doc),
      pageBreak: "auto",
    });

    return doc.lastAutoTable.finalY + 20;
  };
  const renderInitialObservationToPdf = (doc, startY, themeColour, data) => {
    const panelsWithValues = getPanelsWithObservationValues(data);
    if (panelsWithValues.length === 0) return startY;

    doc.setFontSize(14);
    doc.setTextColor("#000");
    doc.text("Initial Observation", margin, startY);
    startY += 15;

    const tableBody = [];

    panelsWithValues.forEach((panel) => {
      panel.tests.forEach((test, index) => {
        tableBody.push([
          index === 0 ? panel.panel_name : "",
          test.test || "-",
          test.value || "-",
          test.unit || "-",
        ]);
      });
    });

    if (tableBody.length === 0) return startY;

    autoTable(doc, {
      startY,
      head: [["Panel", "Test Name", "Value", "Unit"]],
      body: tableBody,
      theme: "grid",
      styles: { fontSize: 9 },
      headStyles: {
        fillColor: hexToRgbArray("#EEEEEE"),
        textColor: hexToRgbArray("#000000"),
      },
      margin: { top: 250, left: margin, right: margin, bottom: 200 },
      didDrawPage: (data) => renderHeaderFooter(data, doc),
      pageBreak: "auto",
    });

    return doc.lastAutoTable.finalY + 10;
  };

  const renderMedicalAdviceToPdf = (
    doc,
    startY,
    themeColour,
    selectedSectionsData
  ) => {
    if (
      !selectedSectionsData ||
      !selectedSectionsData.advice ||
      selectedSectionsData.advice.trim().length === 0
    ) {
      console.log("return-------------", selectedSectionsData);
      return startY;
    }
    console.log("i am in------------------------------------");
    doc.setFontSize(14);
    doc.setTextColor("#000");
    doc.text("Medical Advice", margin, startY);
    startY += 15;

    autoTable(doc, {
      startY,
      head: [["Medical Advice"]],
      body: [[selectedSectionsData.advice]],
      theme: "striped",
      styles: { fontSize: 8 },
      headStyles: { fillColor: hexToRgbArray("#EEEEEE"), textColor: hexToRgbArray("#000000") },
      margin: { top: 250, left: margin, right: margin, bottom: 200 },
      didDrawPage: (data) => renderHeaderFooter(data, doc),
      pageBreak: "auto",
    });

    return doc.lastAutoTable.finalY + 10;
  };

  const renderHeaderFooter = (data, doc) => {
    const pageNumber = doc.internal.getNumberOfPages();
    const midX = pageWidth / 2 + 10; // start a bit after the center

    const currentY = 40; // use margin if needed
    const brandingItem = brandingData?.find(
      (item) => item.name === "branding_statements"
    );
    console.log("brandingItem", brandingItem);
    doc.setFontSize(14);
    doc.setTextColor("#000");
    doc.text("OP Consultation", 40, currentY);

    if (collateralImage) {
      // Preserve aspect ratio and fit within 100x50 box, right-aligned
      const imgType = getImageType(collateralImage).toUpperCase();
      const dataUri = `data:image/${imgType.toLowerCase()};base64,${collateralImage}`;

      const maxWidth = 100;
      const maxHeight = 50;

      let intrinsicWidth = maxWidth;
      let intrinsicHeight = maxHeight;

      // jsPDF can report intrinsic image size; fallback to max box if unavailable
      try {
        const props = doc.getImageProperties
          ? doc.getImageProperties(dataUri)
          : null;
        if (props && props.width && props.height) {
          intrinsicWidth = props.width;
          intrinsicHeight = props.height;
        }
      } catch (e) {
        // ignore and use defaults
      }

      const scale = Math.min(maxWidth / intrinsicWidth, maxHeight / intrinsicHeight);
      const drawWidth = intrinsicWidth * scale;
      const drawHeight = intrinsicHeight * scale;

      // Align to the right margin with a small inward offset
      const leftShift = 40; // move a little left from the right edge
      const x = pageWidth - 40 - drawWidth - leftShift;
      const y = currentY - 20;

      doc.addImage(dataUri, imgType, x, y, drawWidth, drawHeight);
    }
    const clinicAddress = [
      sessionStorage.getItem("facilityAddressLine1"),
      sessionStorage.getItem("facilityAddressLine2"),
      sessionStorage.getItem("facilityAddressLine3"),
    ]
      .filter(Boolean)
      .join(", ");

    doc.setFontSize(10);

    const doctorY = currentY + 40;
    doc.setFontSize(10);
    doc.setTextColor("#000");
    doc.text(displayDoctorName(doctorData), 40, doctorY);
    doc.text(
      `Reg No: ${doctorData?.registration_no ?? "NA"}`,
      40,
      doctorY + 15
    );

    // Wrap qualifications text to half page
    const qualificationsText = `${doctorData?.qualifications || ""}`;
    const wrappedQualifications = doc.splitTextToSize(
      qualificationsText,
      pageWidth / 2 - 40 // half page width
    );

    // Draw qualifications (left-aligned, no awkward gaps)
    doc.text(wrappedQualifications, 40, doctorY + 30);

    // Calculate dynamic Y for department/specialization
    const qualificationsLineCount = wrappedQualifications.length;
    const departmentY = doctorY + 30 + qualificationsLineCount * 12;

    // Wrap department/specialization to half page
    const departmentText = `${doctorData?.department || ""}${doctorData?.specialization ? " - " + doctorData.specialization : ""
      }`;
    const wrappedDepartment = doc.splitTextToSize(
      departmentText,
      pageWidth / 2 - 40
    );

    // Draw department/specialization (left-aligned)
    doc.text(wrappedDepartment, 40, departmentY);

    if (brandingItem?.content?.collateralBrandStatement) {
      doc.text(
        brandingItem.content.collateralBrandStatement,
        pageWidth - 40,
        doctorY,
        {
          align: "right",
        }
      );
    }

    const formattedDate = formatDateIST(dateForAppointment?.toISOString());

    doc.text(`Date: ${formattedDate.split(" ")[0]}`, midX, doctorY + 15);
    doc.text(
      isTodayOrFuture(dateForAppointment) ? `Time: ${formatDateIST(new Date().toISOString()).split(" ").slice(1).join(" ")}` : `Time: ${startTime}`,
      midX,
      doctorY + 30
    );
    doc.text(
      `Clinic Address: ${clinicAddress}`,
      midX, // start from middle
      doctorY + 45, // right below Time
      {
        maxWidth: pageWidth / 2 - 40, // width from middle to right margin
        align: "left", // left-align inside this half
      }
    );

    const patientY = doctorY + 85;
    doc.text(
      `Patient Name: ${displayPatientName(patientData?.name)}`,
      40,
      patientY
    );
    doc.text(`Age: ${patientData?.age}`, 40, patientY + 15);
    doc.text(`Gender: ${patientData?.gender}`, 40, patientY + 30);
    doc.text(`ABHA Address: ${patientData?.abha_id}`, 40, patientY + 45);
    doc.text(`ABHA Number: ${patientData?.abha_no}`, 40, patientY + 60);

    doc.text(`Patient ID: ${patientData?.patient_id}`, midX, patientY);
    doc.text(`Phone: ${patientData?.phone_no}`, midX, patientY + 15);
    doc.text(`Consultation ID: ${selectedContext}`, midX, patientY + 30);
    doc.text(`Visit Purpose: ${selectedContextDisplay}`, midX, patientY + 45);

    doc.line(40, patientY + 75, pageWidth - 40, patientY + 75);
  };

  const renderFooter = (doc, pageNumber) => {
    const brandingItem = brandingData?.find(
      (item) => item.name === "branding_statements"
    );
    const themeColour = brandingItem?.content?.themeColour || "#21cdc0";
    const margin = 5;
    const footerPadding = 10;

    const signatureBlockHeight = 70;
    const signaturePadding = 37;

    const rightX = pageWidth - 200;
    const centerX = pageWidth / 2;

    const departmentText = departments.length
      ? departments.map((d) => d.department).join(" | ")
      : "N/A";

    const poweredText =
      "Enhanced Patient Care Powered by Hlthtek Digital Healthcare Platform (Visit: https://www.hlthtek.com)";
    const logoImg = NavLogoFooter;

    const deptText = `Departments: ${departmentText}`;
    const wrappedDeptText = doc.splitTextToSize(
      deptText,
      pageWidth - 2 * margin
    );
    const deptLineCount = wrappedDeptText.length;
    const lineHeight = 12;
    const baseFooterHeight = 60;

    const dynamicFooterHeight =
      baseFooterHeight + (deptLineCount - 1) * lineHeight;

    const pageBottomY = pageHeight - margin;
    const footerTopY = pageBottomY - dynamicFooterHeight;
    const signatureTopY = footerTopY - signatureBlockHeight - signaturePadding;

    const signature = doctorData?.doctor_signature;
    const imgType = getImageType(signature);
    // 🔹 Move signature & text above it a little
    const moveUpOffset = 10; // tweak this number to adjust position
    const sigTopY = signatureTopY - moveUpOffset;
    const sigImgHeight = 50;
    const sigImgWidth = 100;

    const sigLeftX = rightX;

    // 🔹 Draw Signature First (at top of block)
    if (signature) {
      doc.addImage(
        `data:image/${imgType};base64,${signature}`,
        imgType.toUpperCase(),
        sigLeftX,
        sigTopY,
        sigImgWidth,
        sigImgHeight
      );
    }

    // 🔹 Doctor Text Below Signature
    const startY = sigTopY + sigImgHeight + 10;
    doc.setFontSize(10);
    doc.setTextColor("#000");

    doc.text(displayDoctorName(doctorData), rightX, startY);
    // doc.text(`${doctorData?.qualifications}`, rightX, startY + 15);
    // doc.text(
    //   `Registration No: ${doctorData?.registration_no ?? "NA"}`,
    //   rightX,
    //   startY + 30
    // );

    const rightColumnWidth = pageWidth - rightX - 40; // dynamic column width

    // Wrap qualifications to fit exactly in right column
    const wrappedQualificationsRight = doc.splitTextToSize(
      `${doctorData?.qualifications || ""}`,
      rightColumnWidth
    );

    // Draw qualifications
    doc.text(wrappedQualificationsRight, rightX, startY + 15);

    // Calculate Y for registration number based on wrapped lines

    const regNoY = startY + 15 + wrappedQualificationsRight.length * lineHeight;

    doc.text(
      `Registration No: ${doctorData?.registration_no ?? "NA"}`,
      rightX,
      regNoY
    );

    // const doctorBlockWidth = pageWidth - rightX - 10;

    // const doctorBlockX = rightX; // 40px margin from right edge

    // doc.text(
    //   `${doctorData?.department || ""}${
    //     doctorData?.specialization ? " - " + doctorData.specialization : ""
    //   }`,
    //   doctorBlockX,
    //   startY + 45,
    //   {
    //     maxWidth: doctorBlockWidth, // only wrap within this block
    //     align: "justify", // neat justification
    //   }
    // );
    // 🔹 Footer Background

    doc.setFillColor(...hexToRgbArray(themeColour));
    // doc.rect(
    //   margin,
    //   footerTopY,
    //   pageWidth - 2 * margin,
    //   dynamicFooterHeight,
    //   "F"
    // );
    const footerWidth = pageWidth - 80; // for 40px padding on both sides
    const footerLeftX = 40;

    doc.rect(footerLeftX, footerTopY, footerWidth, dynamicFooterHeight, "F");

    // 🔹 White Text Inside Footer
    doc.setFontSize(9);
    doc.setTextColor("#fff");
    doc.text(wrappedDeptText, centerX, footerTopY + 15, {
      align: "center",
    });

    const poweredY = footerTopY + 15 + deptLineCount * lineHeight;
    doc.setFontSize(9);
    doc.text(poweredText, centerX, poweredY, {
      align: "center",
    });

    // 🔹 Logo below powered text
    if (logoImg) {
      doc.addImage(logoImg, "PNG", centerX - 15, poweredY + 8, 30, 15);
    }
  };

  const getImageType = (base64String) => {
    if (!base64String) return null;

    if (base64String.startsWith("/9j/")) {
      return "jpeg";
    } else if (base64String.startsWith("iVBORw0KGgo")) {
      return "png";
    } else {
      return "jpeg"; // Default fallback
    }
  };

  // Helpers
  const hexToRgbArray = (hex) => {
    const bigint = parseInt(hex.replace("#", ""), 16);
    return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
  };

  const getHeaders = (sectionName) => {
    switch (sectionName) {
      case "History of Past Illness":
      case "History of Present Illness":
        return [
          "Condition",
          "Clinical Notes",
          // "Duration",
          "Clinical Status",
          "Condition Onset",
          "Condition Duration",
        ];
      case "Family History":
        return [
          "Relation",
          "Condition",
          "On Set Age",
          "Deceased",
          "Notes",
          "Condition Onset",
          "Condition Duration",
        ];
      case "Drug History":
        return ["Drug Name", "Drug Onset", "Drug Duration", "Notes"];
      case "Allergies":
        return [
          "Type",
          "Description",
          "Note",
          "Status",
          "Allergy Onset",
          "Allergy Duration",
        ];
      case "Addiction History":
        return ["Type", "Description", "Addiction Onset", "Addiction Duration"];
      case "Surgeries":
        return ["Procedure", "Notes", "Follow Up", "Time Since Surgery"];
      case "Menstrual History":
        return ["Type", "Description", "Time Since Observation"];
      default:
        return [];
    }
  };

  const formatRowData = (sectionName, item) => {
    switch (sectionName) {
      case "History of Past Illness":
      case "History of Present Illness":
        return [
          item.condition,
          item.clinical_note || "-",
          // `${item.duration} ${item.chiefComplaintDurationType || ""}`,
          item.clinical_status_description || "-",
          formatHistoryOnsetForPdf(item, "onset_datetime", "onset_duration", "onset_duration_type"),
          formatHistoryDurationForPdf(
            item,
            "onset_datetime",
            "abatement_datetime",
            "abatement_duration",
            "abatement_duration_type"
          ),
        ];
      case "Family History":
        return [
          item.relation,
          item.condition,
          item.onSetAge,
          item.deceased ? "Yes" : "No",
          item.clinical_note || "-",
          formatHistoryOnsetForPdf(item, "onset_datetime", "onset_duration", "onset_duration_type"),
          formatHistoryDurationForPdf(
            item,
            "onset_datetime",
            "abatement_datetime",
            "abatement_duration",
            "abatement_duration_type"
          ),
        ];
      case "Drug History":
        return [
          item.drug_name,
          formatHistoryOnsetForPdf(item, "onset_datetime", "condition_onset", "condition_onset_type"),
          formatHistoryDurationForPdf(
            item,
            "onset_datetime",
            "abatement_datetime",
            "duration",
            "durationType"
          ),
          item.clinical_note || "-",
        ];
      case "Allergies":
        return [
          item.allergy_type,
          item.allergy_description,
          item.note || "-",
          item.clinical_status_description || "-",
          formatHistoryOnsetForPdf(item, "onset_datetime", "condition_onset", "condition_onset_type"),
          formatHistoryDurationForPdf(
            item,
            "onset_datetime",
            "abatement_datetime",
            "condition_duration",
            "condition_duration_type"
          ),
        ];
      case "Addiction History":
        return [
          item.addiction_type,
          item.addiction_description,
          item?.onset_datetime
            ? formatOnsetDurationForPdf(
              getHumanReadableDiffInPastDateWithAgo(item?.onset_datetime, item)
            )
            : "-",
          item?.abatement_datetime
            ? formatOnsetDurationForPdf(
              getHumanReadableDurationInDate(
                item?.onset_datetime,
                item?.abatement_datetime,
                item
              )
            )
            : "-",
        ];
      case "Surgeries":
        return [
          item.procedure,
          item.clinical_note || "-",
          item.follow_up_description || "-",
          item?.recorded_date
            ? formatOnsetDurationForPdf(
              getHumanReadableDiffInPastDateWithAgo(item?.recorded_date, item)
            )
            : "-",
        ];
      case "Menstrual History":
        return [
          item.menstrualType || "-",
          item.description,
          item?.duration
            ? formatOnsetDurationForPdf(item.duration)
            : item?.durationType
              ? formatOnsetDurationForPdf(
                `${item?.duration || ""} ${item.durationType}`.trim()
              )
              : item?.date
                ? formatOnsetDurationForPdf(
                  getHumanReadableDiffInPastDateWithAgo(item?.date, item)
                )
                : "-",
        ];
      default:
        return [];
    }
  };
  // Utility Functions for rendering additional sections in PDF

  const renderExaminationsToPdf = (
    doc,
    startY,
    themeColour,
    vitals,
    bloodGroup,
    dentalData
  ) => {
    let currentY = startY;

    if (!hasVitalValue && !hasDentalData && !bloodGroup) {
      return startY; // nothing to render
    }
    const margin = 38;

    doc.setFontSize(14);
    doc.setTextColor("#000");
    doc.text("Examination/Vitals", margin, currentY);
    currentY += 15;

    const content = [];

    if (vitals?.length > 0 && hasVitalValue) {
      content.push(["Vitals/Wellness"]);
      vitals.forEach((item) => {
        if (item.value !== "") {
          content.push([`${item.name} - ${item.value} ${item.sign || ""}`]);
        }
      });

      const height = vitals.find((i) => i.name === "Height")?.value;
      const weight = vitals.find((i) => i.name === "Weight")?.value;
      if (height && weight) {
        const bmi = (
          parseFloat(weight) / Math.pow(parseFloat(height) / 100, 2)
        ).toFixed(2);
        content.push([`BMI - ${bmi} kg/m²`]);
      }
    }

    if (bloodGroup) {
      content.push(["Profile"]);
      content.push([`Blood Group - ${bloodGroup}`]);
    }

    if (dentalData?.length > 0 && hasDentalData) {
      content.push(["Dental Examination"]);
      dentalData.forEach((item) => {
        if (item.value !== "") {
          const toothNumbers = item.id
            .split(",")
            .map((id) => id.replace("_", ""))
            .join(", ");
          content.push([`Teeth FDI No. - ${toothNumbers}`]);
          content.push([`Note - ${item.clinical_note}`]);
        }
      });
    }

    if (content.length > 0) {
      autoTable(doc, {
        startY: currentY,
        head: [["Examination/Vitals"]],
        body: content,
        theme: "grid",
        styles: { fontSize: 9 },
        headStyles: { fillColor: hexToRgbArray("#EEEEEE"), textColor: hexToRgbArray("#000000") },
        margin: { top: 250, left: margin, right: margin, bottom: 200 },
        didDrawPage: (data) => renderHeaderFooter(data, doc),
        pageBreak: "auto",
      });

      return doc.lastAutoTable.finalY + 20;
    }

    return currentY;
  };

  const renderAppointmentToPdf = (
    doc,
    startY,
    themeColour,
    followUp,
    referral
  ) => {
    // if (
    //   !Array.isArray(followUp) ||
    //   followUp.length === 0 ||
    //   !Array.isArray(referral) ||
    //   referral.length === 0
    // ) {
    //   return startY;
    // }

    if (
      (!Array.isArray(followUp) || followUp.length === 0) &&
      (!Array.isArray(referral) || referral.length === 0)
    ) {
      return startY;
    }

    const followUpData = followUp[0];
    const referralData = referral[0];

    // doc.setFontSize(14);
    // doc.setTextColor("#000");
    // doc.text("Follow-up & Referral", margin, startY);
    // startY += 15;

    const content = [];
    if (followUpData?.service_type) {
      doc.setFontSize(14);
      doc.setTextColor("#000");
      doc.text("Follow-up & Referral", margin, startY);
      startY += 15;
      if (followUpData.service_type)
        content.push([followUpData.service_type]);
      if (followUpData.duration)
        content.push([`${formatOnsetDurationForPdf(followUpData.duration)}`]);
    }

    if (referralData?.service_description) {
      content.push([`Referral Details - ${referralData.service_description}`]);
      if (referralData.service_category)
        content.push([`Department - ${referralData.service_category}`]);
      if (referralData.doctor_details?.name)
        content.push([`Doctor Name - ${referralData.doctor_details.name}`]);
    }

    if (content.length > 0) {
      autoTable(doc, {
        startY,
        head: [["Follow-up & Referral"]],
        body: content,
        theme: "grid",
        styles: { fontSize: 9 },
        headStyles: { fillColor: hexToRgbArray("#EEEEEE"), textColor: hexToRgbArray("#000000") },
        margin: { top: 250, left: margin, right: margin, bottom: 200 },
        didDrawPage: (data) => renderHeaderFooter(data, doc),
        pageBreak: "auto",
      });
      return doc.lastAutoTable.finalY + 20;
    }

    return startY;
  };

  const renderOtherSectionsToPdf = (
    doc,
    startY,
    themeColour,
    sections = []
  ) => {
    if (!sections || sections.length === 0) return startY;

    doc.setFontSize(14);
    doc.setTextColor("#000");
    doc.text("Diagnosis", margin, startY);
    startY += 15;

    const content = sections.map((item) => {
      const details = [
        item.duration
          ? `Duration - ${formatOnsetDurationForPdf(item.duration)}`
          : null,
        item.clinical_note ? `Clinical Note - ${item.clinical_note}` : null,
      ]
        .filter(Boolean)
        .join(" | ");

      return [
        `${item.term}`,
        details || "-",
      ];
    });

    autoTable(doc, {
      startY,
      head: [["Term", "Details"]],
      body: content,
      theme: "striped",
      styles: { fontSize: 9 },
      headStyles: { fillColor: hexToRgbArray("#EEEEEE"), textColor: hexToRgbArray("#000000") },
      margin: { top: 250, left: margin, right: margin, bottom: 200 },
      didDrawPage: (data) => renderHeaderFooter(data, doc),
      pageBreak: "auto",
    });

    return doc.lastAutoTable.finalY + 20;
  };

  const renderChiefComplaintsToPdf = (
    doc,
    startY,
    themeColour,
    selectedSectionsData
  ) => {
    if (!selectedSectionsData || selectedSectionsData.length === 0)
      return startY;
    doc.setFontSize(14);
    doc.setTextColor("#000");
    doc.text("Chief Complaints", margin, startY);
    startY += 15;
    autoTable(doc, {
      startY,
      head: [["Condition", "Duration", "Status", "Note"]],
      body: selectedSectionsData.map((item) => [
        item.condition || "-",
        item.duration && item.duration.length !== 0
          ? formatOnsetDurationForPdf(item.duration)
          : "-",
        item.clinical_status_description &&
          item.clinical_status_description.length !== 0
          ? item.clinical_status_description
          : "-",
        item.clinical_note && item.clinical_note.length !== 0
          ? item.clinical_note
          : "-",
      ]),
      theme: "striped",
      styles: { fontSize: 8 },
      headStyles: { fillColor: hexToRgbArray("#EEEEEE"), textColor: hexToRgbArray("#000000") },
      margin: { top: 250, left: margin, right: margin, bottom: 200 },
      didDrawPage: (data) => renderHeaderFooter(data, doc),

      pageBreak: "auto",
    });

    return doc.lastAutoTable.finalY + 10;
  };

  const renderProceduresToPdf = (doc, startY, themeColour, procedures) => {
    if (!procedures || procedures.length === 0) return startY;
    doc.setFontSize(14);
    doc.setTextColor("#000");
    doc.text("Procedures", margin, startY);
    startY += 15;
    autoTable(doc, {
      startY,
      head: [["Procedure", "Clinical Note"]],
      body: procedures.map((proc) => [
        proc.term || "-",
        proc.clinical_note && proc.clinical_note.length !== 0
          ? proc.clinical_note
          : "-",
      ]),
      theme: "striped",
      styles: { fontSize: 8 },
      headStyles: { fillColor: hexToRgbArray("#EEEEEE"), textColor: hexToRgbArray("#000000") },
      margin: { top: 250, left: margin, right: margin, bottom: 200 },
      didDrawPage: (data) => renderHeaderFooter(data, doc),

      pageBreak: "auto",
    });

    return doc.lastAutoTable.finalY + 10;
  };

  const checkTotalHistoryData = (medicalBackground) => {
    for (const category in medicalBackground) {
      const { prev, new: newData } = medicalBackground[category];
      console.log("Prev and New", prev, newData);
      if (prev.length > 0) return true;
      if (newData.length > 0) return true;
    }
    return false;
  };
  console.log("SectionsContent", selectedSectionsData);
  return (
    <>
      <div id="prescription-template">
        {sectionsContent !== undefined ? (
          <Card style={{ height: "auto" }}>
            <PdfHeader
              hiType="OP Consultation"
              doctorData={doctorData}
              patientData={patientData}
              selectedContextDisplay={selectedContextDisplay}
              selectedContext={selectedContext}
              dateForAppointment={dateForAppointment}
              startTime={startTime}
            />
            {sections.map((section, index) => (
              <div
                key={index}
                id={section.name}
              // onClick={() => setActiveSection(section.name)}
              >
                {section.name === "History" &&
                  // source === "Doctor Console" &&
                  checkTotalHistoryData(historyDetails) ? (
                  <h2 className="prescriptionh2">{section.displayName || section.name}</h2>
                ) : section.name === "Follow Up/Referral" &&
                  Object.keys(referralError).length == 0 &&
                  Object.keys(followUpError).length == 0 &&
                  ((selectedSectionsData["Referral"].length != 0 &&
                    selectedSectionsData["Referral"][0].service_description
                      .length > 0) ||
                    (selectedSectionsData["FollowUp"].length != 0 &&
                      selectedSectionsData["FollowUp"][0].service_type.length >
                      0) || (selectedSectionsData["IPDAdmissionReferral"].length != 0 &&
                        selectedSectionsData["IPDAdmissionReferral"][0].admission_details.length >
                        0)) ? (
                  <h2 className="prescriptionh2">{section.name}</h2>
                ) : section.name === "Examinations" &&
                  (hasVitalValue || bloodGroup || hasDentalData || otherExaminations?.trim()) ? (
                  <h2 className="prescriptionh2">{section.displayName || section.name}</h2>
                ) : section.name != "History" &&
                  section.name != "Examinations" &&
                  section.name != "Follow Up/Referral" &&
                  selectedSectionsData[section.name] &&
                  selectedSectionsData[section.name].length > 0 ? (
                  <h2 className="prescriptionh2">{section.displayName || section.name}</h2>
                ) : section.name === "Medical Advice" &&
                  selectedSectionsData["MedicalAdvice"]?.advice?.trim() ? (
                  <h2 className="prescriptionh2">{section.displayName || section.name}</h2>
                ) : (
                  ""
                )}
                {/* Box to display suggestions */}
                <div style={{ marginBottom: "10px" }}>
                  {renderEachSection(
                    source,
                    section.name,
                    selectedSectionsData,
                    hasVitalValue,
                    vitals,
                    bloodGroup,
                    hasDentalData,
                    dentalData,
                    historyDetails,
                    followUpError,
                    referralError,
                    // false
                    window.location.pathname,
                    otherExaminations
                  )}
                </div>
              </div>
            ))}
            <PdfFooter doctorData={doctorData} />
          </Card>
        ) : (
          <h1>Loading Clinical consultation report</h1>
        )}
      </div>
      {/* <button onClick={handleDownload} className="listening-button">
        Download
      </button> */}
      <div id="container" style={{ position: "absolute", left: "-9999px" }}>
        {sectionsContent !== undefined ? (
          <Card style={{ height: "auto" }}>
            <PdfHeaderDocs
              hiType="OP Consultation"
              doctorData={doctorData}
              patientData={patientData}
              selectedContextDisplay={selectedContextDisplay}
              selectedContext={selectedContext}
              dateForAppointment={dateForAppointment}
              startTime={startTime}
            />
            {sections.map((section, index) => (
              <div
                key={index}
                id={section.name}
              // onClick={() => setActiveSection(section.name)}
              >
                {section.name === "History" &&
                  // source === "Doctor Console" &&
                  checkTotalHistoryData(historyDetails) ? (
                  <h2 className="prescriptionh2">{section.displayName || section.name}</h2>
                ) : section.name === "Follow Up/Referral" &&
                  Object.keys(followUpError).length == 0 &&
                  Object.keys(referralError).length == 0 ? (
                  <h2 className="prescriptionh2">{section.displayName || section.name}</h2>
                ) : section.name === "Examinations" &&
                  (hasVitalValue || bloodGroup || hasDentalData || otherExaminations?.trim()) ? (
                  <h2 className="prescriptionh2">{section.displayName || section.name}</h2>
                ) : section.name != "History" &&
                  section.name != "Examinations" &&
                  section.name != "Follow Up/Referral" &&
                  selectedSectionsData[section.name] &&
                  selectedSectionsData[section.name].length > 0 ? (
                  <h2 className="prescriptionh2">{section.displayName || section.name}</h2>
                ) : section.name === "Medical Advice" &&
                  selectedSectionsData["MedicalAdvice"]?.advice?.trim() ? (
                  <h2 className="prescriptionh2">{section.displayName || section.name}</h2>
                ) : (
                  ""
                )}
                {/* Box to display suggestions */}
                <div style={{ marginBottom: "10px" }}>
                  {renderEachSection(
                    source,
                    section.name,
                    selectedSectionsData,
                    hasVitalValue,
                    vitals,
                    bloodGroup,
                    hasDentalData,
                    dentalData,
                    historyDetails,
                    followUpError,
                    referralError,
                    // false
                    window.location.pathname,
                    otherExaminations
                  )}
                </div>
              </div>
            ))}
            <PdfFooter doctorData={doctorData} />
          </Card>
        ) : (
          <h1>Loading Clinical consultation report</h1>
        )}
      </div>
    </>
  );
};

export default React.memo(PrescriptionPreview);
